import { PagedRow } from "../../home/models/PageTypes";

export interface RecordInfo extends PagedRow {
    active: boolean;
    created: Date;
    createdBy: string;
    deleted: boolean;
    lastModified: Date;
    lastModifiedBy: string;
}

export const createRecordInfo = (): RecordInfo => ({
    active: false,
    created: new Date(0),
    createdBy: "",
    deleted: false,
    lastModified: new Date(0),
    lastModifiedBy: ""
});